import { gql } from '@apollo/client';
export const WORKFLOW_TASK_FIELDS = gql `
  fragment WorkflowTaskFields on WorkflowTask {
    id
    clientId
    workflowId
    name
    taskType
    sortOrder
    isActive
    targetUserEmail
    targetUserType
    reminders
    expiresAfter
    createdAt
    updatedAt
    isDeleted
    isRequired
  }
`;
export const WORKFLOW_FIELDS = gql `
  ${WORKFLOW_TASK_FIELDS}
  fragment WorkflowFields on Workflow {
    id
    clientId
    name
    type
    executeConcurrently
    isActive
    fallbackUserEmail
    createdAt
    updatedAt
    minApprovalCount
    minRequiredApprovalCount

    workflowTasks {
      ...WorkflowTaskFields
    }
  }
`;
export const WORKFLOWS = gql `
  ${WORKFLOW_FIELDS}
  query WORKFLOWS($spec: WorkflowSpec!) {
    workflows(spec: $spec) {
      ...WorkflowFields
    }
  }
`;
export const SAVE_WORKFLOW = gql `
  ${WORKFLOW_FIELDS}
  mutation SAVE_WORKFLOW($input: WorkflowInput!) {
    saveWorkflow(input: $input) {
      success
      workflow {
        ...WorkflowFields
      }
      messages {
        type
        value
        params
      }
    }
  }
`;
